import { createFileRoute } from "@tanstack/react-router";
import { SamarbejdspartnerePage, samarbejdspartnereHead } from "@/pages/SamarbejdspartnerePage";

export const Route = createFileRoute("/en/business-partners")({
  head: () => samarbejdspartnereHead("en"),
  component: () => <SamarbejdspartnerePage locale="en" />,
});
